export default __webpack_public_path__ + "static/media/gallery1.b5230c26.jpg";